import { AvatarCustom, ReviewRating } from "../../../components";
import { Divider, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";

import { IAppointmentDetails } from "../../../services/appointment-list/appointment-list.interface";
import { ASSIGNED_BOOKING_TYPE, MODALS } from "../../../config/params";
import { formatDoctorNames } from "../../../utils/genericUtils";
import { fromUnixToShortWeekFormat } from "../../../utils/unix-timestamp";
import useAppointmentRatingStore from "../../../hooks/redux-hooks/appointment-rating-store/appointment-rating.store";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../context/ModalContext";

type Props = {
  appointmentData: IAppointmentDetails;
}

const ReviewUpsellCard = (props: Props) => {
  const { appointmentData } = props;
  const isSmallScreen = useMediaQuery("(max-width: 460px)");
  const { openModal } = useModal();
  const { setAppointmentStarRating, userRating } = useAppointmentRatingStore();
  const { setAppointmentDetails } = useAppointmentStore();
  const [value, setValue] = useState<number | null>(0);
  const handleRatingChange = (newValue: number | null) => {
    setAppointmentStarRating(newValue);
    setValue(0);
    openModal(MODALS.RATING_REVIEW_MODAL);
    setAppointmentDetails(appointmentData);
  };

  useEffect(() => {
    if (userRating.starRating === 0) {
      setValue(0);
    }
  }, [userRating.starRating]);

  const bookingDate = fromUnixToShortWeekFormat(appointmentData.start_at, appointmentData.location.timeZone);

  return (
    <div id="review-card-parent" key={userRating.starRating}
      className="flex flex-col my-2 items-center gap-4 self-stretch p-4 rounded-xl bg-taupe-1">
      <div id="appointment-details-section" className="flex items-start gap-3 self-stretch">
        <div id="details" className="flex flex-col items-start gap-1 flex-1">
          <h2 className="text-lg sm:text-xl font-bold leading-6 text-wrap max-w-[90%]">
                    How was {appointmentData.pet.name}&apos;s Appointment?
          </h2>
          <div className="text-sm sm:text-sm leading-5">
            <p>GoodVets {appointmentData.location.locationName}
              <span className="mx-1">&#xb7;</span> {bookingDate.weekday}, {" "}
              {bookingDate.month} {bookingDate.day}</p>
            <p>at {bookingDate.time}  {
              appointmentData &&
              (appointmentData?.appointmentCreateType === ASSIGNED_BOOKING_TYPE.NORMAL_BOOKING) &&
              appointmentData?.resources?.length &&
              appointmentData.resources[0].name &&
              (formatDoctorNames(appointmentData?.resources) !== "") &&
              <span>with <b>{formatDoctorNames(appointmentData?.resources)}</b></span>}</p>
          </div>
        </div>
        <div id="avatars">
          <AvatarCustom
            name={appointmentData?.pet?.name}
            width={isSmallScreen ? 40: 56}
            height={isSmallScreen ? 40: 56}
            image={appointmentData?.pet?.image!}
            className="border-2 border-white bg-white rounded-full"
          />
        </div>
      </div>

      <Divider className="w-full !m-0 border !border-gray-3" />

      {/* Rating Card */}
      <div className="flex flex-col items-start self-stretch gap-3 p-4 rounded-lg bg-white
        border border-taupe-50">
        {/* head */}
        <div className="flex flex-col gap-[2px] items-start">
          <h3 className="text-base font-bold leading-5">How was your appointment?</h3>
          <h3 className="text-sm leading-5">Rate your experience on a scale of 1 to 5 stars.</h3>
        </div>
        {/* head end */}

        {/* rating */}
        <ReviewRating value={value} handleRatingChange={handleRatingChange}/>
        {/* rating end */}

      </div>
      {/* Rating Card End */}
    </div>
  );
};

export default ReviewUpsellCard;
